import styles from './HeroBanner.module.scss';
import clsx from 'clsx';
import Button from '../../atoms/button';
import React from 'react';

export const TeaserButtons = ({ teasers, renderButton, buttonShouldBeInverted }) => {
  if (!teasers && !Array.from(teasers).length) {
    return teasers[0].buttonUrl && teasers[0].buttonTitle && renderButton(teasers[0]);
  }

  return (
    <div className={teasers?.length > 1 ? styles.buttonGroup : styles.buttonGroupSingle}>
      {Array.from(teasers).map((teaser, key) => {
        const teaserButtons = teaser.buttons?.length
          ? teaser.buttons
          : (teaser.buttonUrl && [
              {
                buttonType: teaser.buttonType,
                buttonUrl: teaser.buttonUrl,
                buttonTitle: teaser.buttonTitle,
              },
            ]) ||
            [];

        if (!teaserButtons.length || !teaserButtons.find((btn) => btn.buttonTitle)) {
          return null;
        }

        return (
          teaserButtons?.length && (
            <div
              key={`buttonHolder_${key}`}
              className={clsx(
                styles.buttonHolder,
                styles[`horizontalPosition__center`],
                styles[`verticalPosition__center`],
                { [styles.isSingleBtn]: teaserButtons?.length === 1 },
              )}
            >
              {teaserButtons.map((btn, index) => {
                if (!btn.buttonTitle) return null;
                return (
                  <Button
                    key={`button_${index}`}
                    variant={btn.buttonType}
                    shape="square"
                    isOutlined={false}
                    as={btn.buttonType === 'text' ? 'text' : 'link'}
                    nodeLink={btn.buttonUrl}
                    ariaLabel={btn.buttonTitle}
                    isInverted={buttonShouldBeInverted}
                    className={clsx(styles.heroButton, styles[btn.buttonType])}
                  >
                    {btn.buttonTitle}
                  </Button>
                );
              })}
            </div>
          )
        );
      })}
    </div>
  );
};
